import { baseApi } from "./baseApi";

export const externalAuthApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get connection status for a specific provider
    getConnectionStatus: builder.query({
      query: (provider) => ({
        url: `/external-auth/status/${provider}`,
        method: "GET",
      }),
    }),
    
    // Get all connected providers for the current user
    getConnectedProviders: builder.query({
      query: () => ({
        url: "/external-auth/connected-providers",
        method: "GET",
      }),
    }),
    
    // Disconnect a specific provider
    disconnectProvider: builder.mutation({
      query: (provider) => ({
        url: `/external-auth/disconnect/${provider}`,
        method: "POST",
      }),
      invalidatesTags: ["ExternalAuth"],
    }),
  }),
  overrideExisting: false,
});

export const { 
  useGetConnectionStatusQuery,
  useGetConnectedProvidersQuery,
  useDisconnectProviderMutation
} = externalAuthApi;

export default externalAuthApi;
